export const errorCodes = {
  unconfirmed: 'unconfirmed',
  locked: 'locked',
  locked_assignment_on_resolved_issue: 'locked_assignment_on_resolved_issue',
  locked_approvers_on_resolved_issue: 'locked_approvers_on_resolved_issue',
  not_locked: 'not_locked',
  invalid: 'invalid',
  invalid_token: 'invalid_token',
  already_confirmed: 'already_confirmed',
  confirmation_period_expired: 'confirmation_period_expired',
  confirmation_failed: 'confirmation_failed',
  reset_period_expired: 'reset_period_expired',
};
